export default {"src":"/_next/static/media/kotak_bank.27604725.svg","height":39,"width":77,"blurWidth":0,"blurHeight":0};